export const FREE = 'FREE';
export const MONTHLY = 'MONTHLY'; // Used as a proxy for "recurring", which captures both MONTHLY and YEARLY

export const YEARLY = 'YEARLY';
export const ONE_TIME = 'ONE_TIME';
export const METERED = 'METERED';
export const CONTACT_US = 'CONTACT_US';